module.exports = __webpack_public_path__ + "img/logo-red-footer.fad44621.png";